import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";

export default function SessionExpiredDialog() {
  const { expiredName, clearExpired } = useAuth();
  const navigate = useNavigate();
  const open = !!expiredName;

  const go = () => {
    clearExpired();
    navigate("/login", { replace: true });
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) go(); }}>
      <DialogContent
        data-testid="session-expired-dialog"
        className="max-w-[400px] border-0 bg-transparent p-0 shadow-none [&>button]:hidden"
      >
        <DialogTitle className="sr-only">Sesi berakhir</DialogTitle>
        <div className="frost-card relative overflow-hidden rounded-[28px] px-7 pb-7 pt-9 text-center">
          <div className="relative z-10 flex flex-col items-center">
            <div className="relative mb-5 grid h-[76px] w-[76px] place-items-center">
              <span className="frost-ring absolute inset-0 rounded-full border border-[#9EC6FF]/70" />
              <span className="frost-ring absolute inset-0 rounded-full border border-[#BBD9FF]/60" style={{ animationDelay: "1.4s" }} />
              <span className="frost-icon relative grid h-[72px] w-[72px] place-items-center rounded-full bg-gradient-to-br from-[#F1F8FF] via-[#A6CCF7] to-[#3E86E0] text-[#0A4C9B] shadow-[0_10px_26px_rgba(62,134,224,0.45),inset_0_2px_4px_rgba(255,255,255,0.9)] ring-1 ring-white/70">
                <LogOut className="h-7 w-7" />
              </span>
            </div>
            <h2 className="text-[22px] font-semibold tracking-tight text-[#123A63] [text-shadow:0_1px_0_rgba(255,255,255,0.6)]">
              Sesi berakhir
            </h2>
            <p className="mt-2 text-[14px] leading-relaxed text-[#3E5A78]">
              Anda telah keluar otomatis{expiredName ? `, ${expiredName}` : ""} karena tidak ada aktivitas.
              <br />Silakan masuk kembali untuk melanjutkan.
            </p>
            <button
              data-testid="session-expired-login-btn"
              onClick={go}
              className="mt-6 h-12 w-full rounded-full bg-gradient-to-b from-[#4A94FF] to-[#0071E3] text-[15px] font-semibold text-white shadow-[0_12px_28px_rgba(0,113,227,0.45),inset_0_1px_0_rgba(255,255,255,0.5)] outline-none transition-all hover:from-[#5C9EFF] hover:to-[#0077ED] active:scale-[0.97] focus:outline-none"
            >
              Masuk Lagi
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
